import { Routes, Route } from 'react-router-dom'

import DeviceSearch from 'pages/DeviceSearch'
import MultipleDevices from 'pages/MultipleDevices'

const DevicesRouter = () => {
  return (
    <Routes>
      <Route path="multiple/:id/">
        <Route path=":activeTab" element={<MultipleDevices />} />
        <Route path="" element={<MultipleDevices />} />
      </Route>
      <Route path=":id">
        <Route path=":activeTab" element={<DeviceSearch />} />
        <Route path="" element={<DeviceSearch />} />
      </Route>
      <Route path="?q=:q" element={<DeviceSearch />} />
      <Route index element={<DeviceSearch />} />
    </Routes>
  )
}

export default DevicesRouter
